module.exports = __webpack_public_path__ + "img/coupon_bg.4604f75.png";